import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";

import { HttpResponseHandler } from "./http-response-handler.service";
import { LogService } from "../logger/logger.service";

@Injectable()
export class DataService {
  currentUser: any;
  constructor(
    protected httpClient: HttpClient,
    protected responseHandler: HttpResponseHandler,
    private logger: LogService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.currentUser = this.currentUser != null ? this.currentUser : {};
  }

  //commonly call to the server
  public commonapi(url: any, post: any) {
    console.log("post=====",post)
    let callTime = new Date();
    let resTime;
    return this.httpClient.post(url, JSON.stringify(post)).pipe(
      catchError((err, source) => this.responseHandler.onCatch(err, source)),
      map((data) => {
        resTime = new Date();
        let sec = (resTime.getTime() - callTime.getTime()) / 1000;
        if (data.status) {
          this.logger.apiSuccess(sec, 'data.messagedetails.message', url);
        } else {
          this.logger.apiError(sec, 'data.messagedetails.message', url);
        }
        this.responseHandler.onSuccess(data, url);
        return data;
      })
    );
  }
}
